export const DEFAULT_ID_PROJECT = process.env.VUE_APP_PROJECT_ID

export const CONTEXT_CODES = {
    APPLICATION: 'cabinet_user_concurs'
}

export const ROUTE_PAGE_APPLICATION_FOR_USER = 'my-orders'
export const ROUTE_PAGE_APPLICATION_FOR_MANAGER = 'orders'
export const ROUTE_OPEN_HISTORY_APPLICATION_FOR_USER = '/my-orders?chat='
